import { styled } from '@defa/defa-component-library';

export const Root = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    margin: 20px;
`;
